import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../constants/layout/store/filterSlice";
import moment from "moment";

const PaySlipComponent = ({ result, response, componentRef }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Payslip"));
  }, []);
  const [itSectionTypeGetData, setItSectionTypeGetData] = useState([]);
  const [paySlipData, setPaySlipData] = useState([]);
  const [slipLogo, setSlipLogo] = useState("");
  const [empGetDetails, setGetEmpDetails] = useState([]);
  console.log("empGetDetails:::", empGetDetails);

  const [payRollComponent, setPayRollComponent] = useState([]);
  const [incomeCalculationData, setIncomeCalulationData] = useState([]);
  const [itDetailsData, setItDetailsData] = useState([]);
  const [itTaxInfo, setItTaxInfo] = useState([]);
  const [getApiMessageForTaxType, setGetApiMessageForTaxType] = useState("");
  const [showMoreStatus, setShowMoreStatus] = useState(false);
  useEffect(() => {
    setSlipLogo(response?.data?.logo || "");
    setItDetailsData(result?.itDetails || []);
    setGetApiMessageForTaxType(response?.data?.message || "");
    setItTaxInfo(result?.taxinfo?.[0] || []);
    setIncomeCalulationData(result?.regimePaySlipComponents || []);
    setPaySlipData(result); // ✅ Corrected
    setGetEmpDetails(response?.data?.employeeDetails?.[0] || []);
    setPayRollComponent(result?.payslipComponents || []);
    const itSectionType = result?.itExceptionDetails?.reduce((acc, item) => {
      if (!acc[item.ITSectionType]) {
        acc[item.ITSectionType] = [];
      }
      acc[item.ITSectionType].push(item);
      return acc;
    }, {});

    setItSectionTypeGetData(result?.itExceptionDetails || []);
  }, [result, response]);

  const formatNumber = (num) => {
    return num ? Number(num).toFixed(2) : null;
  };

  const earnings = payRollComponent?.filter(
    (ele) =>
      [239, 244, 1025, 1183, 619].includes(ele.PayrollType_054) &&
      (ele.Amount !== 0 || ele.GrossAmount !== 0)
  );

  const deductions = payRollComponent?.filter(
    (ele) =>
      [237, 238, 243, 1028, 1166, 1274].includes(ele.PayrollType_054) &&
      (ele.Amount !== 0 || ele.GrossAmount !== 0)
  );

  const net = payRollComponent?.find((ele) => ele.PayrollType_054 === 1027);

  const totalEarnings = earnings?.reduce(
    (acc, curr) => acc + (Number(curr.Amount) || 0),
    0
  );
  const totalDeductions = deductions?.reduce(
    (acc, curr) => acc + (Number(curr.Amount) || 0),
    0
  );

  const attendanceDetails = [
    ["Standard Days", Math.floor(empGetDetails?.TotalWorkingDays || 0)],
    [
      "Days Worked",
      Math.floor(empGetDetails?.PresentDays || 0) -
      Math.floor(empGetDetails?.LeaveTaken || 0),
    ],
    ["Loss of Pay Days", Math.floor(empGetDetails?.AbsentDays || 0)],
    ["Leave Taken", Math.floor(empGetDetails?.LeaveTaken || 0)],
    ["Balance Leave", Math.floor(empGetDetails?.LeaveBalance || 0)],
    ["Payment", "Bank Transfer"],
    ["Bank", empGetDetails.BankName || ""],
    ["A/C No.", empGetDetails?.BankAccountNo || ""],
  ];
  let totalCumulative = 0;
  let totalProjected = 0;
  let totalExempted = 0;
  let totalAnnual = 0;

  const formatIndianNumber = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(amount);
  };
  const totGrossAfterSec10 =
    itDetailsData.find((ele) => ele.ITSectionTypes === 1206) || {};
  const IncomeChargeable =
    itDetailsData.find((ele) => ele.ITSectionTypes === 1207) || {};
  const totGrossIncome = itDetailsData.filter(
    (ele) => ele.ITSectionTypes === 1208 || ele.ITSectionTypes === 1209
  );
  const TaxableIncome = itDetailsData.filter(
    (ele) => ele.ITSectionTypes === 1210 || ele.ITSectionTypes === 1211
  );

  function numberToWords(num) {
    // Ensure we are working with an integer
    num = Math.floor(num);
    if (num === 0) return "Zero";

    const belowTwenty = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    function twoDigits(n) {
      if (n === 0) return "";
      else if (n < 20) return belowTwenty[n];
      else return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + belowTwenty[n % 10] : "");
    }

    function threeDigits(n) {
      if (n === 0) return "";
      if (n < 100) return twoDigits(n);
      return (
        belowTwenty[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " and " + twoDigits(n % 100) : "")
      );
    }

    let result = "";

    const crore = Math.floor(num / 10000000);
    if (crore > 0) {
      result += twoDigits(crore) + " Crore ";
      num %= 10000000;
    }

    const lakh = Math.floor(num / 100000);
    if (lakh > 0) {
      result += twoDigits(lakh) + " Lakh ";
      num %= 100000;
    }

    const thousand = Math.floor(num / 1000);
    if (thousand > 0) {
      result += twoDigits(thousand) + " Thousand ";
      num %= 1000;
    }

    result += threeDigits(num);

    return result.trim();
  }
  
  return (
    <div>
      <div
        className="row"
        ref={componentRef}
        id="printSection"
        style={{ padding: "10px" }}
      >
        <div className="col-12">
          <div
            className="payslip-Card"
            style={{ backgroundColor: "#27568B", padding: "35px" }}
          >
            <div className="bg-white h-auto" style={{ padding: "20px" }}>
              {/* Header Section start */}
              <div
                style={{ width: "100%", display: "flex" }}
                id="slipLogoHeader"
              >
                {/* Logo Section*/}
                <div
                  style={{
                    width: "39%",
                    padding: "0px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src={slipLogo || ""}
                    alt="logo"
                    style={{
                      height: "51px",
                      width: "100px",
                      maxWidth: "100%",
                      marginTop: "10px"
                    }}
                    className="img-fluid"
                  />
                </div>

                {/* Content Section */}
                <div
                  style={{
                    width: "57%",
                    textAlign: "left",
                    padding: "0px 0px 0px 10px",
                  }}
                  id="slipHeader"
                >
                  <h6 className="m-0">
                    <b>{empGetDetails?.CompanyName || "Company Name"}</b>
                  </h6>
                  <p style={{ fontWeight: "normal", marginBottom: "10px" }}>
                    {empGetDetails?.CompanyAddress || "Company Address"}
                  </p>
                  <h5 style={{ fontSize: "13px", padding:"0px", margin:"0px" }}>
                    <b>
                      Pay slip for the month of{" "}
                      {empGetDetails?.MonthName || "N/A"}
                    </b>
                  </h5>
                </div>
              </div>
              {/* Header Section end */}
              <hr
                style={{
                  width: "60%",
                  height: "1px",
                  backgroundColor: "black",
                  border: "none",
                  marginLeft: "auto",
                  marginRight: "0",
                  padding: "0px",
                }}
                id="customHrLine"
              />
              {/* Employee Info section start */}
              <div>
                <table
                  style={{
                    width: "78%",
                    borderCollapse: "collapse",
                    margin: "10px 0px",
                  }}
                  id="empDetail"
                >
                  <tbody>
                    <tr style={{ lineHeight: "0.9" }}>
                      <td
                        style={{
                          width: "120px",
                          fontSize: "12px",
                        }}
                      >
                        Employee No
                      </td>
                      <td
                        style={{
                          width: "20px",
                          textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.EmployeeCode || "N/A"}
                      </td>
                      <td
                        style={{
                          width: "120px",
                          fontSize: "12px",
                        }}
                      >
                        Name
                      </td>
                      <td
                        style={{
                          width: "20px",
                          textAlign: "center",
                          fontSize: "12px",
                        }}
                      >
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.EmployeeName || "N/A"}
                      </td>
                    </tr>
                    <tr style={{ lineHeight: "0.9" }}>
                      <td style={{ fontSize: "12px" }}>
                        PAN
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.PAN || "N/A"}
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        Designation
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.Designation || "N/A"}
                      </td>
                    </tr>
                    <tr style={{ lineHeight: "0.9" }}>
                      <td style={{ fontSize: "12px" }}>
                        EPF No.
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.PFNo || "N/A"}
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        Gender
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.Gender || "N/A"}
                      </td>
                    </tr>
                    <tr style={{ lineHeight: "0.9" }}>
                      <td style={{ fontSize: "12px" }}>
                        PF UAN
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.UAN || "N/A"}
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        Date Of Joining
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.JoiningDate? moment(empGetDetails?.JoiningDate).format("DD-MMM-YYYY"):"-" || "N/A"}
                      </td>
                    </tr>
                    <tr style={{ lineHeight: "0.9" }}>
                      <td style={{ fontSize: "12px" }}>
                        Location
                      </td>
                      <td style={{ textAlign: "center", fontSize: "12px" }}>
                        :
                      </td>
                      <td style={{ fontSize: "12px" }}>
                        {empGetDetails?.BranchLocation || "N/A"}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Employee Info section end  */}
              <div id="printSection">
                <h6
                  style={{
                    marginBottom: "5px",
                    color: "#003366",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                  id="slipPayroll"
                >
                  Payroll Details
                </h6>

                <Table
                  striped
                  bordered
                  style={{ width: "100%", marginBottom: "20px" }}
                  id="payrollDetails"
                >
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{
                          width: "20%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Earnings
                      </th>
                      <th
                        style={{
                          width: "10%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          width: "10%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Paid
                      </th>
                      <th
                        style={{
                          width: "20%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Deductions
                      </th>
                      <th
                        style={{
                          width: "10%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Amount
                      </th>
                      <th
                        style={{
                          width: "15%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Attendance
                      </th>
                      <th
                        style={{
                          width: "15%",
                          padding: "0px",
                          fontSize: "12px",
                          backgroundColor: "#C9D5E2",
                        }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({
                      length: Math.max(
                        earnings.length,
                        deductions.length,
                        attendanceDetails.length
                      ),
                    }).map((_, i) => (
                      <tr key={i}>
                        <td
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {
                              earnings[i]?.SalarySlipHead === "Professional Development Allowance" &&
                              moment(empGetDetails?.MonthName, "MMMM YYYY").isBefore(
                                moment("April 2026", "MMMM YYYY")
                              )
                                ? "Spl Allow"
                                : earnings[i]?.SalarySlipHead || ""
                            }
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                          id="tablebodyAmount"
                        >
                          {formatNumber(earnings[i]?.GrossAmount)}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                          id="tablebodyAmount"
                        >
                          {formatNumber(earnings[i]?.Amount)}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {deductions[i]?.SalarySlipHead || ""}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                          id="tablebodyAmount"
                        >
                          {formatNumber(deductions[i]?.Amount)}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                        >
                          {attendanceDetails[i]?.[0] || ""}
                        </td>
                        <td
                          style={{
                            padding: "0px 2px",
                            textAlign: "right",
                            fontSize: "12px",
                            fontWeight: "normal",
                          }}
                          id="tablebodyAmount"
                        >
                          {attendanceDetails[i]?.[1] || ""}
                        </td>
                      </tr>
                    ))}
                    <tr className="total" id="totalEarning">
                      <td style={{ padding: "0px 2px", fontSize: "12px" }}>
                        Total Earnings
                      </td>
                      <td
                        style={{
                          padding: "0px 2px",
                          textAlign: "right",
                          fontSize: "12px",
                        }}
                        colSpan={2}
                        id="tablebodyAmount"
                      >
                        {formatNumber(totalEarnings)}
                      </td>
                      <td style={{ padding: "0px 2px", fontSize: "12px" }}>
                        Total Deductions
                      </td>
                      <td
                        style={{
                          padding: "0px 2px",
                          textAlign: "right",
                          fontSize: "12px",
                        }}
                        id="tablebodyAmount"
                      >
                        {formatNumber(totalDeductions)}
                      </td>
                      <td colSpan={2}></td>
                    </tr>
                    <tr className="total" id="totalEarning">
                      <td colSpan={3}></td>
                      <td style={{ padding: "0px 2px", fontSize: "12px" }}>
                        Net Salary
                      </td>
                      <td
                        style={{
                          padding: "0px 2px",
                          textAlign: "right",
                          fontSize: "12px",
                        }}
                        id="tablebodyAmount"
                      >
                        {formatNumber(net?.Amount)}
                      </td>
                      <td colSpan={2}></td>
                    </tr>
                  </tbody>
                </Table>
                <div
                  // id="payslipTable"
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    marginTop: "-15px",
                  }}
                >
                  <p>
                    In words: <strong>{numberToWords(net?.Amount)}</strong>,
                    will be credited in your bank account No.{" "}
                    {empGetDetails?.BankAccountNo}.
                  </p>
                </div>
                {/* Button wrapper - Hidden when printing */}
                <div className="text-end no-print">
                  <button
                    className="custom-btn-sm"
                    onClick={() => setShowMoreStatus(!showMoreStatus)}
                  >
                    {showMoreStatus ? "Show Less" : "Show More"}
                  </button>
                </div>
              </div>

              {showMoreStatus ? (
                <div
                  class="pageBreak"
                  style={{
                    display: "flex",
                    marginTop: "5px",
                    marginInline: "0px",
                    width: "100%",
                  }}
                  id="incomeSlab"
                >
                  <div
                    style={{
                      width: "70%",
                      pageBreakBefore: "always",
                      breakBefore: "page",
                      // marginRight: "2px",
                    }}
                    id="incomeSlableft"
                  >
                    <Table striped bordered>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              backgroundColor: "#49719e",
                              color: "#fff",
                              padding: "6px 3px",
                            }}
                            colSpan="5"
                          >
                            <p className="m-0" style={{ fontSize: "12px" }} id="slipHeaderInfo">
                              Income Tax Calculation {getApiMessageForTaxType}
                            </p>
                          </td>
                        </tr>
                        <tr className="text-center">
                          <th
                            className="tdBorder"
                            style={{
                              width: "30%",
                              backgroundColor: "#c9d5e2",
                              padding: "0px",
                              fontSize: "12px",
                            }}
                          >
                            Particulars
                          </th>
                          <th
                            className="tdBorder"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px",
                              fontSize: "12px",
                            }}
                          >
                            Cumulative Total
                          </th>
                          <th
                            className="tdBorder"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px",
                              fontSize: "12px",
                            }}
                          >
                            Add:Projected
                          </th>
                          <th
                            className="tdBorder"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px",
                              fontSize: "12px",
                            }}
                          >
                            Less:Exempted
                          </th>
                          <th
                            className="tdBorder"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px",
                              fontSize: "12px",
                            }}
                          >
                            Annual
                          </th>
                        </tr>

                        {incomeCalculationData.map((value, index) => {
                          // Example Usage:
                          totalCumulative += parseFloat(value.Cumulative);
                          totalProjected += parseFloat(value.Projected);
                          totalExempted += parseFloat(value.Exempted);
                          totalAnnual += parseFloat(value.Annual);

                          return (
                            <tr key={index}>
                              <td
                                className="tdBorder"
                                style={{
                                  borderTop: "none",
                                  padding: "0px 2px",
                                  fontWeight: "normal",
                                  fontSize: "12px",
                                }}
                              >
                                {value?.Particulars === "Professional Development Allowance" &&
                                moment(empGetDetails?.MonthName, "MMMM YYYY").isBefore(
                                  moment("April 2026", "MMMM YYYY")
                                )
                                  ? "Spl Allow"
                                  : value?.Particulars || ""}
                              </td>
                              <td
                                className="tdBorder text-end"
                                style={{
                                  borderTop: "none",
                                  padding: "0px 2px",
                                  fontWeight: "normal",
                                  fontSize: "12px",
                                }}
                                id="tablebodyAmount"
                              >
                                {formatIndianNumber(value.Cumulative)}
                              </td>
                              <td
                                className="tdBorder text-end"
                                style={{
                                  borderTop: "none",
                                  padding: "0px 2px",
                                  fontWeight: "normal",
                                  fontSize: "12px",
                                }}
                                id="tablebodyAmount"
                              >
                                {formatIndianNumber(value.Projected)}
                              </td>
                              <td
                                className="tdBorder text-end"
                                style={{
                                  borderTop: "none",
                                  padding: "0px 2px",
                                  fontWeight: "normal",
                                  fontSize: "12px",
                                }}
                                id="tablebodyAmount"
                              >
                                {formatIndianNumber(value.Exempted)}
                              </td>
                              <td
                                className="tdBorder text-end"
                                style={{
                                  borderTop: "none",
                                  padding: "0px 2px",
                                  fontWeight: "normal",
                                  fontSize: "12px",
                                }}
                                id="tablebodyAmount"
                              >
                                {formatIndianNumber(value.Annual)}
                              </td>
                            </tr>
                          );
                        })}
                        <tr className="total Table-header">
                          <td
                            className="tdBorder"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                          >
                            <b>Total</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>{formatIndianNumber(totalCumulative)}</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>{formatIndianNumber(totalProjected)}</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>{formatIndianNumber(totalExempted)}</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              backgroundColor: "#c9d5e2",
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>{formatIndianNumber(totalAnnual)}</b>
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            {totGrossAfterSec10?.Name || "N/A"}
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(totGrossAfterSec10?.ExAmt || 0)}
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            {IncomeChargeable?.Name || "N/A"}
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(IncomeChargeable?.ExAmt || 0)}
                          </td>
                        </tr>

                        <tr className="total">
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{ padding: "0px 2px", fontSize: "12px" }}
                          >
                            <b>Income Chargeable Under Head Salaries</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{ padding: "0px 2px", fontSize: "12px" }}
                            id="tablebodyAmount"
                          >
                            <b>
                              {" "}
                              {formatIndianNumber(
                                totalAnnual -
                                  ((parseFloat(totGrossAfterSec10?.ExAmt) ||
                                    0) +
                                    (parseFloat(IncomeChargeable?.ExAmt) || 0))
                              )}
                            </b>
                          </td>
                        </tr>

                        {totGrossIncome.map((value, index) => (
                          <tr key={index}>
                            <td
                              className="tdBorder"
                              colSpan="4"
                              style={{
                                padding: "0px 2px",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {value.Name}
                            </td>
                            <td
                              className="tdBorder text-end"
                              style={{
                                padding: "0px 2px",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                              id="tablebodyAmount"
                            >
                              {formatIndianNumber(Math.abs(value.ExAmt))}
                            </td>
                          </tr>
                        ))}

                        <tr className="total">
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                          >
                            <b>Gross Total Income</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>
                              {formatIndianNumber(
                                totalAnnual -
                                  ((parseFloat(totGrossAfterSec10?.ExAmt) ||
                                    0) +
                                    (parseFloat(IncomeChargeable?.ExAmt) || 0))
                              )}
                            </b>
                          </td>{" "}
                        </tr>

                        {TaxableIncome.map((value, index) => (
                          <tr key={index}>
                            <td
                              className="tdBorder"
                              colSpan="4"
                              style={{
                                padding: "0px 2px",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                            >
                              {value.Name}
                            </td>
                            <td
                              className="tdBorder text-end"
                              style={{
                                padding: "0px 2px",
                                fontSize: "12px",
                                fontWeight: "normal",
                              }}
                              id="tablebodyAmount"
                            >
                              {formatIndianNumber(Math.abs(value.ExAmt))}
                            </td>
                          </tr>
                        ))}

                        <tr className="total">
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                          >
                            <b>Net Taxable Income</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>
                              {formatIndianNumber(
                                itTaxInfo?.NetTaxableIncome || 0
                              )}
                            </b>
                          </td>
                        </tr>

                        <tr className="Table-info">
                          <td
                            colSpan="5"
                            style={{
                              backgroundColor: "#49719e",
                              color: "#fff",
                              padding: "6px 3px",
                            }}
                          >
                            <p
                              className="m-0"
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                              id="slipHeaderInfo"
                            >
                              Income Tax Deduction
                            </p>
                          </td>
                        </tr>
                        <tr className="total">
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                          >
                            <b>Income Tax On Total Income Payable</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>
                              {formatIndianNumber(
                                itTaxInfo?.IncomeTaxOnTotalIncomePayable
                              )}
                            </b>
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Rebate Under Section 87
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(
                              itTaxInfo?.RebateUnderSection87
                            )}
                          </td>
                        </tr>

                        <tr className="total">
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                          >
                            <b>Total Tax Due</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>{formatIndianNumber(itTaxInfo?.TotalTaxDue)}</b>
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Surcharge on Income Tax
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(
                              itTaxInfo?.SurchargeOnIncomeTax
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Education Cess
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(itTaxInfo?.EducationCess)}
                          </td>
                        </tr>

                        <tr className="total">
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                          >
                            <b>Total Income Tax & S/C & Cess Payable</b>
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                            }}
                            id="tablebodyAmount"
                          >
                            <b>
                              {formatIndianNumber(
                                itTaxInfo?.TotalIncomeTaxAndSCAndCessPayable
                              )}
                            </b>
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Less Tax Deducted Till Date
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(
                              itTaxInfo?.LessTaxDeductedTillDate
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Balance
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(itTaxInfo?.Balance)}
                          </td>
                        </tr>

                        <tr>
                          <td
                            className="tdBorder"
                            colSpan="4"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                          >
                            Avg. Monthly I, Tax & S/C Cess to be Recovered
                          </td>
                          <td
                            className="tdBorder text-end"
                            style={{
                              padding: "0px 2px",
                              fontSize: "12px",
                              fontWeight: "normal",
                            }}
                            id="tablebodyAmount"
                          >
                            {formatIndianNumber(
                              itTaxInfo?.AvgMonthlyTaxAndSCAndCessToBeRecovered
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                  <div
                    style={{
                      width: "30%",
                      pageBreakBefore: "always",
                      breakBefore: "page",
                    }}
                  >
                    <Table striped bordered>
                      <tbody id="incomeSlabright">
                        {Object.entries(
                          itSectionTypeGetData.reduce((acc, item) => {
                            if (!acc[item.ITSectionType]) {
                              acc[item.ITSectionType] = [];
                            }
                            acc[item.ITSectionType].push(item);
                            return acc;
                          }, {})
                        ).map(([ITSectionType, itSectionItems], index) => (
                          <React.Fragment key={index}>
                            {/* Section Header Row */}
                            <tr>
                              <td
                                colSpan={8}
                                id="txbdody"
                                style={{
                                  backgroundColor: "#49719e",
                                  color: "#fff",
                                  padding: "6px 3px",
                                  fontSize: "12px",
                                }}
                                className="font-bold"
                              >
                                {ITSectionType}
                              </td>
                            </tr>

                            {/* Sub-Table inside a row */}
                            <tr>
                              <td style={{ padding: "0px" }} colSpan={8}>
                                <Table
                                  style={{
                                    borderSpacing: "0",
                                    marginBottom: "0",
                                    paddingBottom: "0",
                                  }}
                                  id="itSectionTable"
                                >
                                  <tbody style={{ margin: "0", padding: "0" }}>
                                    {itSectionItems.map((data, subIndex) => (
                                      <tr key={subIndex}>
                                        <td
                                          style={{
                                            padding: "0px 2px",
                                            fontWeight: "normal",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {data.ITName}
                                        </td>
                                        <td
                                          className="text-end"
                                          style={{
                                            padding: "0px 2px",
                                            fontWeight: "normal",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {formatIndianNumber(data.Amount)}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              ) : null}
              <div id="payableNotes">
                <div id="payableNote" class="remark-container">
                  <blockquote class="remark">NOTE:</blockquote>
                </div>
                <div
                  id="payableNoteDetails"
                  class="text-center"
                  style={{ fontSize: "12px" }}
                >
                  ** This is a computer-generated payslip and does not require a
                  signature or stamp.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaySlipComponent;